import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { DeleteCompanyModel } from 'src/app/admin-panel/models/members/delete-company.model';
import { MemberCompanyService } from 'src/app/admin-panel/services/members/member-companies.service';

@Component({
  selector: 'app-archive-member-company',
  templateUrl: './archive-member-company.component.html',
  styleUrls: ['./archive-member-company.component.scss']
})
export class ArchiveMemberCompanyComponent implements OnInit {

    //#region Fields
    public unsubscribe: Subject<void> = new Subject<void>();
    public spinner: boolean = false;
    public deleteCompanyModel : DeleteCompanyModel = new DeleteCompanyModel()
    public active:boolean=false;
    //#endregion
    //#region Constructor
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    public memberCompanyService: MemberCompanyService
  ) {
    if (this.config.data != undefined && this.config.data.id) {     
      this.deleteCompanyModel.companyId = this.config.data.id;
      this.active = this.config.data.active
    }
   }

  ngOnInit(): void {
  }
  //#endregion
   //#region Public Methods
   suspendcompany() {
    this.spinner = true
    this.memberCompanyService.suspendcompany(this.deleteCompanyModel)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe({
      next: (response) => {  
        this.spinner = false      
        this.ref.close(true)
      },
      error: errorResponse => {
        this.spinner = false 
      }
    });
  }
  unsuspendcompany(){
    this.spinner = true
    this.memberCompanyService.unsuspendcompany(this.deleteCompanyModel)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe({
      next: (response) => {  
        this.spinner = false      
        this.ref.close(true)
      },
      error: errorResponse => {
        this.spinner = false 
      }
    });
  }
  cancel() {
    this.ref.close(false)
  }
  //#endregion
}
